import { MenuItem, Stack } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react'
import { RHFTextField } from '../components/hook-form';

export default function CategoryComponent({
  selectedCategory, setSelectedCategory,
  classVal, setClass,
  centralExam, setCentralExam,
  stateExam, setStateExam,
  selectedState, setSelectedState,
  selectedBoard, setSelectedBoard,
  width,
  examName = null,
  setExamName = () => {}
}) {

// console.log("",selectedCategory)
    const [subCategories, setSubCategories] = useState([]);
    const [states, setStates] = useState(); 
    const [boards, setBoards] = useState();
    const [isCategoryLoading, setIsCategoryLoading] = useState(false);

    const isClassCategory = selectedCategory === 'class';
    const isStateCategory = selectedCategory === 'state-exam';
    const isCentralCategory = selectedCategory === 'central-exam';


    const streamCategory = [
        {
          id:"class",
          title:"School Exams"
        },
        {
          id:"central-exam",
          title:"Central Exams"
        },
        {
          id:"state-exam",
          title:"State Exams"
        },
      ]


      const handleCategoryChange = async (event) => {
        const selectedCategoryId = event.target.value;
        // console.log(selectedCategoryId);
        // console.log(event.target.value);
        setStates(null);
        setBoards(null);
        setSubCategories(null);
        setSelectedBoard(null);
        setSelectedState(null);
        setExamName(null);
        
        setIsCategoryLoading(true);
        setSelectedCategory(selectedCategoryId);
    
        const token = localStorage.getItem("token");
        switch (selectedCategoryId) {
          case 'central-exam':
            const centralExams = await axios.post(`${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-central-exams`, {
              headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }});
            setSubCategories(centralExams?.data?.data);
            break;
    
          case 'state-exam':
            const stateList = await axios.post(`${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-states`, {
              headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }});
            console.log(stateList?.data?.data)
            setStates(stateList?.data?.data);
            break;
          
          case 'class':
            const boardsList = await axios.post(`${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-boards`, {
              headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }});
            // console.log(boardsList?.data?.data)
            setBoards(boardsList?.data?.data);
            break;
    
          default:
            break;
        }
        // Fetch subcategories based on the selected category
        setIsCategoryLoading(false);
       
      };


      const handleStateChange = async(e)=>{
        setIsCategoryLoading(true);
        setSelectedState(e.target.value);
        const currentState = e.target.value;
        setSubCategories(null);
        const stateExamsList = await axios.post(`${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-state-exams`, {state_exam_id: currentState})
        console.log(stateExamsList.data)
        setSubCategories(stateExamsList.data?.data); 
        setIsCategoryLoading(false);
      }


      const handleBoardChange = async(e)=>{
        setIsCategoryLoading(true);
        const currentBoard = e.target.value;
        setSelectedBoard(e.target.value);
        setSubCategories(null);
        const boardExamsList = await axios.post(`${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-classes`, {board_id: currentBoard})
        console.log(boardExamsList.data)
        setSubCategories(boardExamsList.data?.data); 
        setIsCategoryLoading(false);
      }


      const handleSubCategoryChange = (e)=>{
        setClass(null);
        setStateExam(null);
        setCentralExam(null);
        setExamName(null);

        const selectedOption = subCategories?.find((subcategory) => String(subcategory.id) === String(e.target.value));
        const selectedLabel =
          selectedOption?.exam_name ||
          selectedOption?.name ||
          selectedOption?.class_name ||
          "";

        if (isClassCategory) {
          setClass(e.target.value);
          setExamName(selectedLabel);
        } else if (isStateCategory) {
          setStateExam(e.target.value);
          setExamName(selectedLabel);
        } else if (isCentralCategory) {
          setCentralExam(e.target.value);
          setExamName(selectedLabel);
        }
    
        console.log("boards", classVal);
        console.log("states", stateExam);
        console.log("central", centralExam);
    
      }



  return (
    <Stack direction={"row"} spacing={3} width={width}>
                <RHFTextField
                  name="category"
                  label="Category"
                  disabled={isCategoryLoading}
                  sx={{ width: "50%" }}
                  select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  {streamCategory?.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.title}
                    </MenuItem>
                  ))}
                </RHFTextField>

                {states && <RHFTextField
                  name="states"
                  label="State"
                  disabled={isCategoryLoading}
                  sx={{ width: "50%" }}
                  select
                  value={selectedState}
                  onChange={handleStateChange}
                >
                  {states?.map((state, index) => (
                    <MenuItem key={index} value={state.id}>
                      {state.name}
                    </MenuItem>
                  ))}
                </RHFTextField>}

                {boards && <RHFTextField
                  name="boards"
                  label="Boards"
                  disabled={isCategoryLoading}
                  sx={{ width: "50%" }}
                  select
                  value={selectedBoard}
                  onChange={handleBoardChange}
                >
                  {boards?.map((board, index) => (
                    <MenuItem key={index} value={board.id}>
                      {board.name}
                    </MenuItem>
                  ))}
                </RHFTextField>}

                <RHFTextField
                  name="subCategory"
                  label="Subcategory"
                  disabled={isCategoryLoading}
                  sx={{ width: "50%" }}
                  select
                  value={
                    (isClassCategory && (classVal?.id || classVal)) ||
                    (isStateCategory && (stateExam?.id || stateExam)) ||
                    (isCentralCategory && (centralExam?.id || centralExam)) ||
                    ""
                  }
                  onChange={handleSubCategoryChange}
                >
                  {/* Show options if subCategories exist */}
                  {subCategories && subCategories.length > 0 ? (
                    subCategories.map((subcategory, index) => (
                      <MenuItem key={index} value={subcategory.id}>
                        {subcategory?.exam_name || subcategory?.name || subcategory?.class_name}
                      </MenuItem>
                    ))
                  ) : (
                    // If editing and no subCategories loaded, show the loaded value (exam_name, class_name, etc.)
                    ((isClassCategory && classVal) || (isStateCategory && stateExam) || (isCentralCategory && centralExam)) && (
                      <MenuItem
                        key="loaded"
                        value={
                          (isClassCategory && (classVal?.id || classVal)) ||
                          (isStateCategory && (stateExam?.id || stateExam)) ||
                          (isCentralCategory && (centralExam?.id || centralExam)) ||
                          ""
                        }
                      >
                        {(() => {
                          if (isClassCategory) {
                            if (classVal && typeof classVal === 'object') {
                              return classVal.class_name || classVal.name;
                            }
                            return examName || classVal;
                          }
                          if (isStateCategory) {
                            if (stateExam && typeof stateExam === 'object') {
                              return stateExam.exam_name || stateExam.name;
                            }
                            return examName || stateExam;
                          }
                          return examName || centralExam;
                        })()}
                      </MenuItem>
                    )
                  )}
                </RHFTextField>
              </Stack>
  )
}
